import PdfToLabelListing from '../components/Brazil/PdfToLabelListing';
import LabelToSectionListing from '../components/Brazil/LabelToSectionListing';

const BRAZIL_BASE_ROUTE = '/brazil';

const BRAZIL_ROUTES = [
  {
    id: 'brazilPdfToLabelListing',
    path: `${BRAZIL_BASE_ROUTE}/pdf-to-label/listing`,
    component: PdfToLabelListing,
    exact: true
  },
  {
    id: 'brazilLabelToSectionListing',
    path: `${BRAZIL_BASE_ROUTE}/label-to-section/listing`,
    component: LabelToSectionListing,
    exact: true
  }
];

export default BRAZIL_ROUTES;
